import * as React from 'react';
import { IBoxProps } from '../Box';
import { Grid, GridProps } from '@mui/material';

export interface IColProps extends Omit<IBoxProps, 'colSpan'> {
  /**
   * Column span at each theme breakpoint
   * @example colspan={{ _: '12', md: '6' xl: '3' }}
   */
  colspan?: any;
}


const Col: React.FC<IColProps & GridProps> = ({ colspan = {}, children, ...style }) => {
  const { xs, sm, md, lg, xl } = colspan;

  return (
    <Grid
      item
      xs={+xs}
      sm={+sm}
      md={+md}
      lg={+lg}
      xl={+xl}
      {...(style as GridProps)}
    >
      {children}
    </Grid>
  );
};

Col.displayName = 'Col';

export default Col;
